import { Component, OnInit, OnDestroy,ViewChild,ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { ContextMenuService } from '../../../services/contextMenu/context-menu.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-re-age',
  templateUrl: './re-age.component.html',
  styleUrls: ['./re-age.component.scss']
})
export class ReAgeComponent implements OnInit,OnDestroy {
  display:boolean = false;  
  linkExceptionModel:any;
  selectedMenuItem:any;
  isMessage:boolean = true;
  subManager = new Subscription();
  headerText = "Re-Age";
  labelText = "Are you sure you want to Re-Age Inquiries?";

  constructor(private contextMenuService:ContextMenuService) {
  }

  ngOnInit() {
  }

  @ViewChild('cancelBtn') cancelBtn!: ElementRef;

  ngAfterViewInit() {
    
    setTimeout(() =>{if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    } 
    }, 100);
  }
  
  triggerFalseClick() {
    this.headerText = "Re-Age";
    this.labelText = "Are you sure you want to Re-Age Inquiries?";
    this.isMessage = true;
    this.display = true;
  }

  hideModal(){
    this.display = false;
  }

  getFormattedText(text: string): string {
    return text ? text.replace(/\*\*(.*?)\*\*/g, '<span class="bold-text">$1</span>') : '';
  }

  private toInquiryIdString(value: unknown): string {
    if (value === null || value === undefined) {
      return '';
    }
    switch (typeof value) {
      case 'string':
        return value;
      case 'number':
      case 'boolean':
      case 'bigint':
        return String(value);
      default:
        // Avoid default object stringification like "[object Object]".
        return '';
    }
  }

  private escapeForInnerHtml(value: string): string {
    return value
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;')
      // Prevent user data from interfering with the **bold** formatting.
      .replaceAll('*', '&#42;');
  }

  private formatInquiryList(items: unknown[], maxDisplay: number): { displayed: string; extraText: string } {
    const safeItems = (items ?? []).map(item => this.escapeForInnerHtml(this.toInquiryIdString(item)));
    const displayed = safeItems.slice(0, maxDisplay).join(', ');
    const extraCount = safeItems.length - maxDisplay;
    const extraText = extraCount > 0 ? ` (+${extraCount} more)` : '';
    return { displayed, extraText };
  }

  updateReAge() {
    const action = "Re Age Inquiry";
    let sub1 = this.contextMenuService.httpReAgeInquiry(this.selectedMenuItem, action).subscribe(result => {
      const maxDisplay = 7;
      
      if (Array.isArray(result?.newRequests) && result?.newRequests?.length > 0) {
        const { displayed, extraText } = this.formatInquiryList(result.newRequests, maxDisplay);
        this.labelText = `**Re-age** request for Inquiry(s) ${displayed}${extraText} sent to Supervisor for approval.`;
      }
      else if (Array.isArray(result?.oldRequests) && result?.oldRequests?.length > 0) {
        const { displayed, extraText } = this.formatInquiryList(result.oldRequests, maxDisplay);
        this.labelText = `**Re-age** request for Inquiry(s) ${displayed}${extraText} already sent and awaiting Supervisor approval.`;
      }
      else if (Array.isArray(result?.autoApproved) && result?.autoApproved?.length > 0) {
        const { displayed, extraText } = this.formatInquiryList(result.autoApproved, maxDisplay);
        this.labelText = `**Re-age** request for Inquiry(s) ${displayed}${extraText} is **successful**.`;
      }
      else {
        this.labelText = 'No inquiries were returned for Re-age.';
      }
      this.isMessage = false;
      this.headerText = "Re-Age Confirmation";
    });
    this.subManager.add(sub1);
    //this.hideModal();
  }

  ngOnDestroy(){
    this.subManager.unsubscribe();
  }
}
